function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#ffd800",
  d: "M1.512 6.328a8.745 8.745 0 013.885-3.167v2.221a6.739 6.739 0 105.589-.5V7.49l-3.5-3.745L10.986 0v2.789a8.8 8.8 0 014.616 3.042 8.645 8.645 0 011.876 5.405A8.739 8.739 0 111.512 6.328z"
});
function SvgUndoActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.477,
    height: 19.974,
    viewBox: "0 0 17.477 19.974"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='17.477' height='19.974' viewBox='0 0 17.477 19.974'%3e %3cpath fill='%23ffd800' d='M6.328 15.966a8.745 8.745 0 0 1-3.167-3.885h2.221a6.739 6.739 0 1 0-.5-5.589H7.49l-3.745 3.5L0 6.492h2.789a8.8 8.8 0 0 1 3.042-4.616A8.645 8.645 0 0 1 11.236 0a8.739 8.739 0 1 1-4.908 15.966z' transform='rotate(90 8.739 8.739)'/%3e %3c/svg%3e";
export { SvgUndoActive as ReactComponent };